<div class="our-students-tooltip">
  <span *ngIf="student[column.id]">
    <div class="top-row">
      <div class="label">{{ student[column.id].label }}</div>
      <div class="overall-and-change">
        <div class="overall" [ngStyle]="{ color: student[column.id].color }">
          <ng-container *ngIf="student[column.id].alpha">
            {{ student[column.id].alpha }}
          </ng-container>
          <ng-container *ngIf="!student[column.id].alpha">
            {{ student[column.id].prefix
            }}{{
              column["roundTo"] !== undefined
                ? (student[column.id].y
                  | number: "1." + column["roundTo"] + "-" + column["roundTo"])
                : (student[column.id].y | number)
            }}{{ student[column.id].suffix }}
          </ng-container>
        </div>
        <div class="change">
          <img
            *ngIf="
              student[column.id].changeDirection == 'up' &&
              student[column.id].upIsGood
            "
            class="arrow"
            [src]="'../../assets/images/arrow_up_green.svg'"
          />
          <img
            *ngIf="
              student[column.id].changeDirection == 'up' &&
              !student[column.id].upIsGood
            "
            class="arrow"
            [src]="'../../assets/images/arrow_up_red.svg'"
          />
          <img
            *ngIf="
              student[column.id].changeDirection == 'down' &&
              student[column.id].upIsGood
            "
            class="arrow"
            [src]="'../../assets/images/arrow_down_red.svg'"
          />
          <img
            *ngIf="
              student[column.id].changeDirection == 'down' &&
              !student[column.id].upIsGood
            "
            class="arrow"
            [src]="'../../assets/images/arrow_down_green.svg'"
          />
          <img
            *ngIf="
              student[column.id].changeDirection == 'none'
            "
            class="arrow_sideways"
            [src]="'../../assets/images/arrow_sideways.svg'"
          />
          <p
            class="change-value"
            *ngIf="student[column.id].changeValue"
            [ngStyle]="{ color: student[column.id].changeColor }"
          >
            {{ student[column.id].prefix
            }}{{
              column["roundTo"] !== undefined
                ? (student[column.id].changeValue
                  | number: "1." + column["roundTo"] + "-" + column["roundTo"])
                : (student[column.id].changeValue | number)
            }}{{ student[column.id].suffix }}
          </p>
        </div>
      </div>
    </div>
    <div class="overall-description">
      <p>
        {{ student.firstName }} {{ student.lastName }}
        {{ student[column.id].descriptor }}
      </p>
    </div>
    <div class="change-description">
      <p>{{ student[column.id].changeDescriptor }}</p>
    </div>
  </span>
  <span *ngIf="!student[column.id]">
    <span class="metric-tooltip title school_comp_title capitalize tile_body"
      >No data available</span
    >
    <div class="metric-tooltip school_comp_description body_tooltip_text">
      We couldn't find any data for this metric.
    </div>
  </span>
</div>
